import React, {Component} from 'react';
import CONSTANTS from '../../config/constants';
import Youtube from 'react-youtube';
import _ from "lodash";

class VideoBlock extends Component {
    getContentFieldValue = (fieldDefinitionKey) => {
        const {contentFields} = this.props;
        const data = _.find(contentFields, {fieldDefinitionKey: fieldDefinitionKey});

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }
        return false
    };

    getBlockWidth = () => {
        const {width} = this.props;

        let w = 60;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            if (this.getContentFieldValue('Width') && this.getContentFieldValue('Width') !== CONSTANTS.BLOCK_DEFAULT_WIDTH && this.getContentFieldValue('Width') !== w) {
                w = this.getContentFieldValue('Width');
            }
        }

        return w;
    };

    getYoutubeId(url){
        url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_-]/i)[0] : url[0];
    }

    render() {
        const videoOptions = {
            width: '100%',
            height: '100%'
        };

        const data = {
            title: this.getContentFieldValue('Title'),
            content: this.getContentFieldValue('Content'),
            youtubeUrl: this.getContentFieldValue('YoutubeUrl')
        };

        var videoId = null;

        if (data.youtubeUrl) {
            videoId = this.getYoutubeId(data.youtubeUrl);
        }

        return (
            <section className={"video-block w--" + this.getBlockWidth() + " show--shadow"}>
                {videoId && 
                    <Youtube
                        videoId={videoId}
                        opts={videoOptions}
                        className="youtube"
                        containerClassName="youtube--wrapper"
                    />
                }

                <div className="content">
                    <div className="content--inner">
                        <h3>{data.title}</h3>
                        <div dangerouslySetInnerHTML={{__html: data.content}}>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default VideoBlock;


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/VideoBlock.js